/**
 * Format amount with currency for display.
 * @param {number|string|null|undefined} amount
 * @param {string} [currency='']
 * @returns {string}
 */
export function formatCurrency(amount, currency = '') {
  if (amount == null || amount === '') return '–';
  const n = Number(amount);
  if (Number.isNaN(n)) return '–';
  const formatted = n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return currency ? `${currency} ${formatted}` : formatted;
}
